import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "users-page" }
const _hoisted_2 = { class: "toolbar" }

import { ref, onMounted, computed, reactive } from "vue";
import { ElMessage, ElMessageBox } from "element-plus";
import { UserServiceApi, TenantServiceApi } from "@/services/dataService";
import { useStore } from "vuex";

interface UiUserItem {
  id: number;
  username: string;
  display_name?: string;
  role: string;
  is_active?: boolean;
  created_at?: string;
  tenant_id?: number | string;
  tenant_name?: string;
  tenant_subname?: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'UsersManagement',
  setup(__props) {

const store = useStore();
const role = computed(() => store.getters.getUserRole);
const isSuperAdmin = computed(() => role.value === "super_admin");
const isAdmin = computed(() => role.value === "admin");
const tenants = ref<{ id: string | number; name: string }[]>([]);

const users = ref<UiUserItem[]>([]);
const loading = ref(false);
const createVisible = ref(false);
const createForm = reactive({
  username: "",
  display_name: "",
  password: "",
  role: "operator",
  tenant_id: undefined as string | number | undefined,
});

const showTenantSelect = computed(
  () => isSuperAdmin.value && createForm.role !== "super_admin"
);

const fetchUsers = async () => {
  loading.value = true;
  try {
    const resp = await UserServiceApi.listUsers({});
    const payload = (resp as { data?: { data?: { items?: UiUserItem[] } } })
      .data?.data;
    users.value = (payload?.items as UiUserItem[]) || [];
  } finally {
    loading.value = false;
  }
};

const fetchTenants = async () => {
  try {
    const resp = await TenantServiceApi.listTenants({ page_size: 100 });
    const payload = (
      resp as {
        data?: { data?: { items?: { id: string | number; name: string }[] } };
      }
    )?.data?.data;
    tenants.value =
      (payload?.items as { id: string | number; name: string }[]) || [];
  } catch (err) {
    console.error("加载租户列表失败", err);
  }
};

const openCreate = () => {
  createForm.username = "";
  createForm.display_name = "";
  createForm.password = "";
  createForm.role = isSuperAdmin.value ? "operator" : "operator"; // admin 仅 operator
  createForm.tenant_id = undefined;
  if (isSuperAdmin.value) {
    fetchTenants();
  }
  createVisible.value = true;
};

const createUser = async () => {
  if (!createForm.username || !createForm.password) {
    ElMessage.warning("请输入用户名与密码");
    return;
  }
  if (showTenantSelect.value && !createForm.tenant_id) {
    ElMessage.warning("请选择租户");
    return;
  }
  const resp = await UserServiceApi.createUser({
    ...createForm,
    is_active: true,
  });
  const ok =
    (resp as { data?: { code?: number; message?: string } }).data?.code === 0;
  if (ok) {
    ElMessage.success("用户创建成功");
    createVisible.value = false;
    fetchUsers();
  } else {
    const msg =
      (resp as { data?: { message?: string } }).data?.message || "创建失败";
    ElMessage.error(msg);
  }
};

const canDelete = (row: UiUserItem) => {
  if (isSuperAdmin.value) return true;
  if (isAdmin.value && row.role === "operator") return true;
  return false;
};

const onDelete = (row: UiUserItem) => {
  ElMessageBox.confirm(
    `确认删除用户 ${row.username} ？此操作不可撤销。`,
    "确认删除",
    {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning",
    }
  )
    .then(async () => {
      const resp = await UserServiceApi.deleteUser(row.id);
      const rs = resp as {
        data?: { code?: number; message?: string };
        status?: number;
      };
      const ok = rs.data?.code === 0 || rs.status === 204;
      if (ok) {
        ElMessage.success("用户已删除");
        fetchUsers();
      } else {
        const msg =
          (resp as { data?: { message?: string } }).data?.message || "删除失败";
        ElMessage.error(msg);
      }
    })
    .catch(() => {
      // 用户取消
    });
};

const formatDate = (d: string) => {
  if (!d) return "—";
  try {
    return new Date(d).toLocaleString();
  } catch {
    return String(d);
  }
};

onMounted(fetchUsers);

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_button, {
        type: "primary",
        onClick: openCreate
      }, {
        default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
          _createTextVNode("新增用户", -1)
        ]))]),
        _: 1
      })
    ]),
    _createVNode(_component_el_table, {
      data: users.value,
      style: {"width":"100%"}
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          prop: "username",
          label: "用户名",
          width: "180"
        }),
        _createVNode(_component_el_table_column, {
          prop: "display_name",
          label: "显示名称",
          width: "180"
        }),
        _createVNode(_component_el_table_column, {
          prop: "role",
          label: "角色",
          width: "140"
        }),
        (isSuperAdmin.value)
          ? (_openBlock(), _createBlock(_component_el_table_column, {
              key: 0,
              prop: "tenant_name",
              label: "租户",
              "min-width": "180",
              sortable: ""
            }))
          : _createCommentVNode("", true),
        (isSuperAdmin.value)
          ? (_openBlock(), _createBlock(_component_el_table_column, {
              key: 1,
              prop: "tenant_subname",
              label: "子域名",
              "min-width": "160",
              sortable: ""
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_el_table_column, {
          prop: "is_active",
          label: "状态",
          width: "120"
        }, {
          default: _withCtx((scope) => [
            _createVNode(_component_el_tag, {
              type: scope.row.is_active ? 'success' : 'info'
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(scope.row.is_active ? "启用" : "禁用"), 1)
              ]),
              _: 2
            }, 1032, ["type"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "created_at",
          label: "创建时间"
        }, {
          default: _withCtx((scope) => [
            _createTextVNode(_toDisplayString(formatDate(scope.row.created_at)), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "操作",
          width: "150"
        }, {
          default: _withCtx((scope) => [
            (canDelete(scope.row))
              ? (_openBlock(), _createBlock(_component_el_button, {
                  key: 0,
                  type: "danger",
                  size: "small",
                  onClick: ($event: any) => (onDelete(scope.row))
                }, {
                  default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                    _createTextVNode("删除", -1)
                  ]))]),
                  _: 1
                }, 8, ["onClick"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data"]),
    _createVNode(_component_el_dialog, {
      modelValue: createVisible.value,
      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((createVisible).value = $event)),
      title: "新增用户",
      width: "480px"
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, {
          onClick: _cache[5] || (_cache[5] = ($event: any) => (createVisible.value = false))
        }, {
          default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
            _createTextVNode("取消", -1)
          ]))]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: createUser
        }, {
          default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
            _createTextVNode("创建", -1)
          ]))]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          model: createForm,
          "label-width": "100px"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, { label: "用户名" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: createForm.username,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((createForm.username) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "显示名称" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: createForm.display_name,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((createForm.display_name) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "密码" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: createForm.password,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((createForm.password) = $event)),
                  type: "password",
                  "show-password": ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "角色" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: createForm.role,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((createForm.role) = $event)),
                  style: {"width":"100%"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_option, {
                      label: "操作员",
                      value: "operator"
                    }),
                    (isSuperAdmin.value)
                      ? (_openBlock(), _createBlock(_component_el_option, {
                          key: 0,
                          label: "管理员",
                          value: "admin"
                        }))
                      : _createCommentVNode("", true),
                    (isSuperAdmin.value)
                      ? (_openBlock(), _createBlock(_component_el_option, {
                          key: 1,
                          label: "超级管理员",
                          value: "super_admin"
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            (showTenantSelect.value)
              ? (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 0,
                  label: "租户"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      modelValue: createForm.tenant_id,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((createForm.tenant_id) = $event)),
                      style: {"width":"100%"},
                      placeholder: "请选择租户"
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tenants.value, (tenant) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: tenant.id,
                            label: tenant.name,
                            value: tenant.id
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ])), [
    [_directive_loading, loading.value]
  ])
}
}

})